import { autocorrectTLDs } from "../../util/emails";

export const SIGNUP_STATUS = Object.freeze({
  missingEmail: "Please provide an email address",
  subscribed: "Thank you!",
});

export const planNewsletterSignup = ({ email, pathname }) => {
  const address = autocorrectTLDs(email.trim());

  return address
    ? { request: { email: address, source: "footer", location: pathname } }
    : { rejection: SIGNUP_STATUS.missingEmail };
};

export const signupStatus = (request, result) =>
  result.ok
    ? SIGNUP_STATUS.subscribed
    : result.message ?? `Unable to subscribe ${request.email}`;
